import FailedOrdersModule from '@/modules/failed-orders';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/failed-orders')({
  component: FailedOrdersPage,
});

function FailedOrdersPage() {
  return <FailedOrdersModule />;
}
